
    /**
     * Method delayer
     */
    export class MethodDelayer {

        private static  delayedMethods = {};

        /**
         * Delays a method (static).  Used for auto-complete pulldown delays
         * @param label
         * @param callback
         */
        static delayMethod(label, callback) {

            MethodDelayer.delayedMethods[label] = Date.now();
            var t = MethodDelayer.delayedMethods[label];
            setTimeout(() => {
                if (MethodDelayer.delayedMethods[label] !== t) {
                        return;
                    } else {
                        callback();
                    }
                },
                500);
        }
    }








// WEBPACK FOOTER //
// ./ClientApp/scripts/common/ah.mb.common.method-delayer.ts